import React, { PureComponent } from "react";
import Slider from "react-slick";

import Media from "Common/Media";
import MediaFetching from "Common/MediaFetching";

import styles from "./MediaListSlick.local.scss";
import classnames from "classnames";
//import _ from "i18n";

export default class MediaListSlickComponent extends PureComponent {
  render() {
    const {
      medias = [],
      community,
      fetching,
      editor,
      uploadingMedias = []
    } = this.props;
    let { styleClass, stepMedia } = this.props;
    styleClass = styleClass ? styleClass : "large-2";
    stepMedia = stepMedia ? stepMedia : 6;
    if (fetching) {
      return (
        <ul className={classnames(styles.list, "grid-x")}>
          {Array(stepMedia)
            .fill("")
            .map(el => (
              <li
                className={`cell smal-12 medium-4 ${styleClass}`}
                key={`media-fetching-${el}`}
              >
                <MediaFetching />
              </li>
            ))}
        </ul>
      );
    }

    const listItems = [];

    if (uploadingMedias) {
      uploadingMedias.forEach(({ id, progress, file }) => {
        listItems.push(
          <li key={id} className="cell smal-12 medium-4 large-2">
            <div
              className={`${styles.uploadingMedia}`}
              style={{
                backgroundImage: `url("${URL.createObjectURL(file)}")`
              }}
            >
              <div className={styles.uploadingMediaOverlay} />
              <div
                className="progress"
                role="progressbar"
                aria-valuenow={progress}
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <span
                  className="progress-meter"
                  style={{ width: `${progress}%` }}
                />
              </div>
            </div>
          </li>
        );
      });
    }

    if (medias) {
      medias.forEach(media => {
        listItems.push(
          <li
            className={`cell smal-12 medium-4 ${styleClass}`}
            key={`media-container-${media.id}`}
          >
            <Media media={media} community={community} editor={editor} />
          </li>
        );
      });
    }

    let blocs = [];

    for (let i = 0; i < listItems.length; i += stepMedia) {
      blocs[i / stepMedia] = [];
      for (let j = i; j < Math.min(listItems.length, i + stepMedia); j++) {
        blocs[i / stepMedia].push(listItems[j]);
      }
    }
    const settings = {
      dots: true,
      dotsClass: "slick-dots",
      infinite: false,
      arrows: true,
      speed: 500,
      autoplay: false
    };

    return (
      <div className="section-content">
        <Slider {...settings}>
          {blocs.map(bloc => (
            <div className="slick-block" key={Math.random()}>
              <ul className={classnames(styles.list, "grid-x")}>{bloc}</ul>
            </div>
          ))}
        </Slider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Community/MediaListSlick/MediaListSlickComponent.js